export const GA_TRACKING_ID = 'AW-11435369610';

let isProduction = true;

if (window.location.origin.includes('localhost') || window.location.origin.includes('staging')) {
    isProduction = false;
}

export const isGtagEnabled = () => isProduction;

export enum EVENT_NAMES {
    APP_OPEN = 'APP OPEN',
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const trackPageView = (url: string) => {
    if (!isGtagEnabled()) return;
    if (window && window.gtag !== undefined) {
        window.gtag('config', GA_TRACKING_ID, {
            page_path: url,
        });
    }
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const TrackGoogleEvent = ({
    action,
    category,
    label,
    value,
}: {
    action: string;
    category?: string;
    label?: string;
    value?: string;
}) => {
    console.log('here is gtag for dashboard', isGtagEnabled());
    if (!isGtagEnabled()) return;
    console.log('OK');
    if (window && typeof window.gtag === 'function') {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
};
